export interface OuvidoriaRelatorioMensal {
  id: string;
  ouvidoria_id: string;
  municipio_id: string;
  ano: number;
  mes: number;
  total_solicitacoes: number;
  total_concluidas: number;
  total_pendentes: number;
  media_tempo_primeira_resposta_horas: number | null;
  media_tempo_encaminhamento_horas: number | null;
  media_tempo_resolucao_horas: number | null;
  percentual_primeira_resposta_dentro_prazo: number | null;
  percentual_resolucao_dentro_prazo: number | null;
  maior_tempo_primeira_resposta_horas: number | null;
  maior_tempo_resolucao_horas: number | null;
  media_atualizacoes_por_solicitacao: number | null;
  media_intervalo_atualizacoes_horas: number | null;
  gerado_em: string;
  gerado_por_sistema: boolean;
  created_at: string;
  updated_at: string;
}

export interface RelatorioAnual {
  ano: number;
  meses: OuvidoriaRelatorioMensal[];
  resumo: {
    total_solicitacoes: number;
    total_concluidas: number;
    total_pendentes: number;
    media_tempo_resolucao_horas: number | null;
    percentual_resolucao_dentro_prazo: number | null;
  };
}

export const MESES_NOMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export const MESES_ABREV = [
  'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
];
